import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
    anomalies: [],
}

const name = 'anomalies'
const parentSelector = state => state?.[name]

const anomaliesSlice = createSlice({
    name: name,
    initialState: initialState,
    reducers: {
        resetAnomalies: () => {
            return initialState;
        },
        setAnomalies: (state, action) => {
            return {
                ...state,
                anomalies: action.payload,
            };
        },
    },
});


const getAnomalies = createSelector(parentSelector, state => {
    return state?.anomalies
})


const actions = {
    ...anomaliesSlice.actions
}

const selectors = {
    getAnomalies
}

export const anomaliesActions = { actions, selectors }

export default anomaliesSlice;